/* eslint-disable prettier/prettier */
import { X } from 'lucide-react';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  disableOutsideClick?: boolean;
  hideCloseButton?: boolean;
};

export const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  disableOutsideClick = false,
  hideCloseButton = false,
}: ModalProps) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (!disableOutsideClick) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 "
      onClick={handleBackdropClick}
    >
      <div
        className="w-[70%] sm:w-[50%] bg-white max-w-lg rounded-2xl p-4 px-7 relative shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {!hideCloseButton && (
          <button
            onClick={onClose}
            className="absolute text-lg font-extrabold top-6 right-5 text-primary"
          >
            <X />
          </button>
        )}

        {title && <h2 className="mt-2 mb-3 text-2xl font-extrabold text-primary">{title}</h2>}
        {children}
      </div>
    </div>
  );
};
